var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  "+_vm._s(_vm.text)+" "),_c('br'),_c('br'),_vm._v(" "),_c('a',{staticStyle:{"color":"#195300"},attrs:{"href":_vm.pdfUrl,"target":"_blank"}},[_vm._v(_vm._s(_vm.buttonText))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-731c4ba6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/ToastAlert.vue
// module id = null
// module chunks = 